/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
// import produce from 'immer';
// import UploadService from '../../../../app/pages/ComposeEmail/UploadFileService';
// import { LinearProgress, Box, Typography } from '@material-ui/core';
// import { TooltipHost, Link } from "@fluentui/react";
// import { FontIcon } from '@fluentui/react/lib/Icon';
import numeral from "numeral";
// import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { v4 as uuid_v4 } from "uuid";

import { ActionButton } from '@fluentui/react/lib/Button';
// import download from 'js-file-download';
// import axios from "axios";

// const Url = process.env.REACT_APP_API_URL;

// function LinearProgressWithLabel(props) {
//     return (
//         <Box display="flex" alignItems="center">
//             <Box width="100%" mr={1}>
//                 <LinearProgress variant="determinate" {...props} />
//             </Box>
//             <Box minWidth={35}>
//                 <Typography variant="body2" color="textSecondary">{`${Math.round(
//                     props.value,
//                 )}%`}</Typography>
//             </Box>
//         </Box>
//     );
// }

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    maxWidth: '510px',
    maxHeight: '450px',
    overflow: 'auto'
};

//   const img = {
//     display: 'block',
//     width: '100%',
//     height: '100%'
//   };


const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    // width: 100,
    // height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

export function AttachmentPreview({
    fileSizeLimit,
    uploadType,
    downloadFileUrl,
    onAttachmentChange,
    file,
    onAttachmentError,
    signatureURL
}) {
    let dropzoneRef;
    // const [currentUploadingFile, setCurrentUploadingFile] = useState([]);
    const [currentFile, setCurrentFile] = useState({
        file: null,
        fileData: null
    });

    useEffect(() => {
        setCurrentFile({
            file: null,
            fileData: null
        });
    }, []);

    useEffect(() => {
        // console.log(files);
        if (file) {
            setCurrentFile(file);
        }
    }, [file]);

    const GetFileNameAndExtension = (filename) => {
        // const name = file.name;
        const lastDot = filename.lastIndexOf('.');

        const fileName = filename.substring(0, lastDot);
        const ext = filename.substring(lastDot + 1);
        return { fileName, ext };
    }

    // const handleRemove = (file) => {
    //     // setCurrentUploadingFile(produce((draft) => { return draft.filter(f => f.new_file_uid !== file.new_file_uid) }));        
    // };

    // const handleDownloadAttachment = async (new_file_uid, extension, filename) => {
    //     const res = await axios.get(Url + downloadFileUrl, { params: { new_file_uid, extension }, responseType: 'blob' });
    //     download(res.data, filename);
    // }

    // useEffect(() => {
    //     // console.log(currentUploadingFile);
    //     if (onAttachmentListChange) {
    //         onAttachmentListChange(currentUploadingFile);
    //     }
    // }, [currentUploadingFile]);

    // const uploadAttachment = (currentFile, data) => {     
    //     UploadService.upload(currentFile, data, uploadType, (event) => {    
    //         setCurrentFile(produce((draft) => {  
    //             draft.percent = Math.round((100 * event.loaded) / event.total); 
    //         }));
    //     })
    //     .then((response) => {
    //         setCurrentFile(produce((draft) => { 
    //             draft.percent = 0;
    //         })); 
    //     })
    //     .catch((e) => { 
    //         handleRemove(data);
    //         console.log(e); 
    //     });
    // }

    const onFileDrop = (filesVal, rejectedFiles) => {
        // console.log(filesVal);
        // console.log(rejectedFiles);
        if (onAttachmentError && rejectedFiles.length > 0) {
            let _err = "The file you are trying to attach exceed the 25MB attachment size limit.";
            if (rejectedFiles[0].errors[0].code !== 'file-too-large') {
                _err = rejectedFiles[0].errors[0].message;
            }
            onAttachmentError(_err);
        }
        if (filesVal.length === 0) return;

        const fileDetails = GetFileNameAndExtension(filesVal[0].name);
        const data = {
            new_file_uid: uuid_v4(),
            filename: filesVal[0].name,
            extension: fileDetails.ext,
            // uploaded_by: currentUser.user.username
        }
        // let oldFiles = files;
        // // const filesLimit = 3;
        // oldFiles = oldFiles.concat(filesVal);
        const _file = {
            new_file_uid: data.new_file_uid,
            percent: 1,
            name: filesVal[0].name,
            extension: fileDetails.ext,
            filename: fileDetails.fileName,
            size: numeral(filesVal[0].size).format('0.00b'),
            preview: URL.createObjectURL(filesVal[0])
        };

        const _d = filesVal[0];
        setCurrentFile({
            file: _file,
            fileData: _d
        });
        if (onAttachmentChange) {
            onAttachmentChange({ file: _file, fileData: _d });
        }
        // uploadAttachment(filesVal[0], data);
    };

    // useEffect(() => {
    //     console.log(currentFile);
    // }, [currentFile]);

    // const attachmentBtns = (file, index) => (<>
    //     <div style={{ display: 'flex' }}>
    //         <div>
    //             <TooltipHost content="Remove attachment" >
    //                 <FontIcon iconName='Delete' style={{ color: '#000' }} onClick={() => handleRemove(file)} /> 
    //             </TooltipHost>
    //         </div>
    //         <div>
    //             <TooltipHost content="Download attachment" >
    //                 <FontIcon iconName='Download' style={{ color: '#000', marginLeft: 5 }} onClick={() => { handleDownloadAttachment(file.new_file_uid, file.extension, file.name) }} />                   
    //             </TooltipHost>
    //         </div>
    //     </div>
    // </>);

    return (<>
        <ActionButton onClick={() => { dropzoneRef.open(); }} iconProps={{ iconName: 'Attach', className: 'attachment-icon' }}
            styles={{
                icon: { color: 'black' },
                root: {
                    selectors: {
                        ':hover .ms-Button-icon': {
                            color: 'rgb(0, 120, 212)'
                        }
                    }
                }
            }}
        >
            <span style={{ fontWeight: 500 }}>Change Signature</span> <span style={{ fontWeight: 400, fontSize: 12, paddingLeft: 10, color: '#000' }}> Maximum size: 25MB</span>
        </ActionButton>
        {/* <Label><FontIcon iconName='Attach'/> Attachments <span style={{ fontWeight:400, fontSize:12, paddingLeft:10 }}> Maximum size: 25MB</span> </Label> */}

        {/* </div> */}
        <Dropzone
            acceptClassName="stripes"
            onDrop={onFileDrop}
            onDropRejected={() => console.log('test')}
            maxSize={fileSizeLimit}
            // maxFiles={2}
            ref={(node) => { dropzoneRef = node; }}
            style={{ border: '0px solid #c7c7c7' }}
            activeStyle={{ backgroundColor: '#fafafa' }}
            accept='image/jpeg,image/png,image/gif'
        >
            {({ getRootProps, getInputProps }) => (
                <div className='dropzone'>
                    {currentFile && currentFile.file &&
                        <div style={thumb} key={currentFile.file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={currentFile.file.preview}
                                    // style={img}
                                    alt="Digital Signature"
                                />
                            </div>
                        </div>
                    }
                    {
                        (currentFile && !currentFile.file && signatureURL) &&
                        <div style={thumb} key="currentsignature">
                            <div style={thumbInner}>
                                <img src={signatureURL} alt="Digital Signature" />
                            </div>
                        </div>

                    }

                    <div {...getRootProps()}>
                        <input {...getInputProps()} />

                        <div style={{ color: '#BABEC5', fontStyle: 'italic', cursor: 'pointer', textAlign: 'center', paddingBottom: '10px' }}>Drag/Drop files here, or click to select files</div>
                    </div>
                </div>
            )}
        </Dropzone>
    </>)
}